import {AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {OrderService} from '~/app/core/common/services/order.service';
import {AuthServicesService, JwtService} from 'mclane-webauth-lib';
import {ScheduleService} from '~/app/core/common/services/schedule.service';
import {OrderSchedule} from '~/app/core/common/models/orderSchedule';
import {ConfigurationService} from '~/app/core/common/services/configuration.service';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {OrderScheduleStatus} from '~/app/core/common/enums/OrderScheduleStatus';
import {GlobalMessageBoxService} from '~/app/web/global-message-box.service';
import {Nomenclatures} from '~/app/core/common/enums/Nomenclatures';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {Store} from '~/app/core/common/models/store';
import {
    WarningDialogContentComponent
} from '~/app/web/components/warning-dialog-content/warning-dialog-content.component';
import {DialogHelperComponent, DialogType} from '~/app/shared/helpers/dialog-helper';
import {throwError} from 'rxjs';
import {GlobalErrorHandlerService} from '~/app/shared/services/globalErrorHandlerService';
import {DOCUMENT} from "@angular/common";
import {LoadingIndicatorHelper} from "~/app/shared/helpers/loading-indicator-helper";


// Event colors need to move to its own configurations
@Component({
    selector: 'app-home',
    styleUrls: ['home.component.scss'],
    templateUrl: 'home.component.html'
})
export class HomeComponent implements OnInit, AfterViewInit {

    public nextOrderDue: OrderSchedule = new OrderSchedule();
    public mostRecentPlacedOrder: OrderSchedule = new OrderSchedule();
    public storeChangable = true;
    username: string;
    public events: any[] = [];

    response: any;
    missing: string;
    pdf: string;

    constructor(private router: Router,
                private orderService: OrderService,
                private Auth: AuthServicesService,
                public dialogHelper: DialogHelperComponent,
                private configurationService: ConfigurationService,
                public callSchedule: ScheduleService,
                private _storeListService: StoreListService,
                private ref: ChangeDetectorRef,
                public messageBox: GlobalMessageBoxService,
                public applicationSettings: ApplicationSettingsHelper,
                public storeListService: StoreListService,
                public jwtService: JwtService,
                public globalErrorHandlerService: GlobalErrorHandlerService,
                @Inject(DOCUMENT) private document: Document,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
    ) {

    }

    private static getTime(date?: Date) {
        return date != null ? new Date(date) : 0;
    }

    // Begin an unscheduled order
    async startUnscheduledOrder() {

        // FSPORTAL-248 not allowing mulitple orders to be placed if order is already due or started
        const unscheduledOrderMsg = 'The calendar indicates that you have a scheduled order available or have an incomplete order already '
            + 'started. Please return to the calendar and complete the order by selecting the correct day.';

        const unscheduledOrderMsgTracking = 'Calendar out of sync. You have a scheduled order available or have an incomplete order already '
            + 'started. Refreshing data now.';


        const eventTitles = this.callSchedule.events.filter(event => {
            const today = new Date();
            const callDate = new Date(event.meta.callDate);
            if (today.getDate() === callDate.getDate() && today.getMonth() === callDate.getMonth()) {
                if (event.meta.status === OrderScheduleStatus.STARTED.toString() || event.meta.status === OrderScheduleStatus.DUE.toString()) {
                    return 1;
                } else {
                    return 0;
                }
            }
        });

        let trackingIdCheck = await this.orderService.checkOpenOrder(
            this._storeListService.pickedCustomerId)
            .toPromise().then().catch((error) => {
                console.error('error with check open order: ', error);
                return error;
            })
            .then((trackingId: any) => {
                if (trackingId === null) {
                    console.error('Problem Making calls to the service');
                    return '0';
                } else {
                    return trackingId;
                }
            });


        // SOURCELINK-1114
        // TODO call /order/openorder/{custid} to check if there is an openorder not displayed on the UI
        // Case would be 2 users on calendar screen user1 creates the unscheduled order and saves so they now have tracking id
        // user2 is still on the calendar without the order showing yet bc they haven't refreshed and they click
        // unsch order so it creates another order for the same day


        if (eventTitles.length > 0) {
            await this.dialogHelper.open(
                {
                    type: DialogType.WARNING,
                    title: 'Incomplete Order - ' + await trackingIdCheck,
                    content: unscheduledOrderMsg,
                    actions: [
                        {text: 'Ok', themeColor:"primary"}
                    ],
                    width: 400
                });
        } else if (trackingIdCheck > 0) {
            this.dialogHelper.open(
                {
                    type: DialogType.WARNING,
                    title: 'Incomplete Order - ' + await trackingIdCheck,
                    content: unscheduledOrderMsgTracking,
                    actions: [
                        {text: 'Ok', themeColor:"primary"}
                    ],
                    width: 400
                }).then(results => {
                if (results === 'Ok') {
                    this.applicationSettings.setTrackingId('');
                    if (this.jwtService.roles !== undefined) {
                        this.createCalendarObject().then(r => r);
                        this.ref.detectChanges();
                    }
                }
            });
        } else {
            await this.dialogHelper.open(
                {
                    type: DialogType.WARNING,
                    title: 'Warning!',
                    content: WarningDialogContentComponent,
                    actions: [
                        {text: 'Cancel'},
                        {text: 'Ok',themeColor:"primary"}
                    ],
                    width: 600
                }).then(results => {

                if (results === 'Ok') {
                    this.applicationSettings.setTrackingId('');
                    this.configurationService.setOrderStatus('none');

                    this.router.navigateByUrl('/ordering').catch();
                }
            });
        }
    }

    async ngOnInit() {

        this.applicationSettings.setTrackingId('');

    }

    ngAfterViewInit() {
        if (this.jwtService.roles !== undefined) {
            this.createCalendarObject().then(r => r);
            this.ref.detectChanges();
        }
    }

    ReloadDataPage() {
        this.createCalendarObject().then(r => r);
    }

    async createCalendarObject() {
        this._loadingIndicatorHelper.show('');
        const pickedCustomerId = await this.storeListService.pickedCustomerIdVerify();
        await this.callSchedule.getOrderSchedules(pickedCustomerId.toString());
        await this.callSchedule.updateCalendarEvents();
        await this.GetLastPlacedOrder(this.callSchedule.orderSchedule);
        await this.GetNextOrderDue(this.callSchedule.orderSchedule);
        this._loadingIndicatorHelper.hide();
    }

    GetDatesWithoutTimes(date: Date) {
        return date.setHours(0, 0, 0, 0);
    }

    async CalendarEventClicked($event: any) {
        const event = $event.event;
        this.applicationSettings.setEvent(JSON.stringify(event.meta));
        this.applicationSettings.setEventStatus(event.meta.status);
        this.configurationService.setOrderStatus(event.meta.status);
        const pickedCustomerId = await this._storeListService.pickedCustomerIdVerify();
        this.applicationSettings.setCustomerId(pickedCustomerId.toString());

        const orderDate = this.GetDatesWithoutTimes(new Date(event.meta.callDate));
        const todaysDate = this.GetDatesWithoutTimes(new Date());

        if (event.meta.status === OrderScheduleStatus.SHIPPED.toString()) {
            this.StartInventoryCheck().then(() => {
            });

        } else if (event.meta.status === OrderScheduleStatus.PLACED.toString() ||
            event.meta.status === OrderScheduleStatus.CONFIRMED_ACK.toString()
            || event.meta.status === OrderScheduleStatus.CONFIRMED.toString()
            || event.meta.status === OrderScheduleStatus.DELIVERED.toString()) {
            this.applicationSettings.setTrackingId(event.meta.trackingId); // TODO
            this.router.navigateByUrl('/orderconfirm').catch();
        } else if (event.meta.status === OrderScheduleStatus.DUE.toString() && orderDate >= todaysDate) {

            const orderClickedDate = new Date(Math.floor(new Date(orderDate).getTime() / 86400000 + 1) * 86400000 + new Date(orderDate).getTimezoneOffset() * 60000 - 1000);
            const nextOrderDate = new Date(Math.floor(new Date(this.nextOrderDue.callDate).getTime() / 86400000 + 1) * 86400000 + new Date(this.nextOrderDue.callDate).getTimezoneOffset() * 60000 - 1000);

            if (orderClickedDate > nextOrderDate) {
                await this.dialogHelper.open(
                    {
                        type: DialogType.WARNING,
                        title: 'Warning',
                        content: 'You must complete your next scheduled order before building this order.',
                        actions: [
                            {text: 'Ok'},
                        ],
                        width: 400
                    });

            } else {
                this.applicationSettings.setTrackingId(event.meta.trackingId); // TODO
                this.router.navigateByUrl('/ordering').catch();
            }


        } else if (event.meta.status === OrderScheduleStatus.STARTED.toString() && orderDate >= todaysDate) {
            this.applicationSettings.setTrackingId(event.meta.trackingId); // TODO
            this.router.navigateByUrl('/ordering').catch((error) => {
                console.error(error);
            });
        }
    }

    async updateAppStoreSection(store: Store) {
        await this._storeListService.updateStoreSelection(store).then(selectedStore => {

            this.createCalendarObject();
        });

    }

    async GetNextOrderDue(schedules: OrderSchedule[]) {

        const filteredSchedules = schedules.filter((value) => {
            const actualDate = new Date();
            const eodDate = new Date(Math.floor(actualDate.getTime() / 86400000 + 1) * 86400000 + actualDate.getTimezoneOffset() * 60000 - 1000);
            const eodCallDate = new Date(Math.floor(new Date(value.callDate).getTime() / 86400000 + 1) * 86400000 + new Date(value.callDate).getTimezoneOffset() * 60000 - 1000);

            return HomeComponent.getTime(eodCallDate) >= HomeComponent.getTime(eodDate)
                && value.status === OrderScheduleStatus.DUE.toString()
                || HomeComponent.getTime(eodCallDate) >= HomeComponent.getTime(eodDate) &&
                value.status === OrderScheduleStatus.STARTED.toString();
        });

        const filterList = filteredSchedules.sort((a: OrderSchedule, b: OrderSchedule) => {
            return +HomeComponent.getTime(a.callDate) - +HomeComponent.getTime(b.callDate);
        });

        if (filterList.length > 0) {
            this.nextOrderDue = filterList[0];
        } else {
            this.nextOrderDue = null;
        }
    }

    async GetLastPlacedOrder(schedules: OrderSchedule[]) {
        const filteredSchedules = await schedules.filter((value) => {
            return value.status === OrderScheduleStatus.PLACED.toString()
                || value.status === OrderScheduleStatus.CONFIRMED.toString()
                || value.status === OrderScheduleStatus.CONFIRMED_ACK.toString()
                || value.status === OrderScheduleStatus.SHIPPED.toString()
                || value.status === OrderScheduleStatus.DELIVERED.toString();
        });
        const filterList = filteredSchedules.sort((a: OrderSchedule, b: OrderSchedule) => {
            return +HomeComponent.getTime(b.callDate) - +HomeComponent.getTime(a.callDate);
        });
        if (filterList.length > 0) {
            this.mostRecentPlacedOrder = filterList[0];
        } else {
            this.mostRecentPlacedOrder = null;
        }
    }

    async startScheduledOrder(trackingId: string, customerId: number) {
        this.applicationSettings.setTrackingId(trackingId);
        this.router.navigateByUrl('/ordering').catch();
    }

    startRecentReview(nextOrderDue: OrderSchedule) {
        if (nextOrderDue === null || nextOrderDue === undefined) {
            return;
        }

        this.configurationService.setOrderStatus(nextOrderDue.status);
        this.applicationSettings.setEvent(JSON.stringify(nextOrderDue));
        this.applicationSettings.setEventStatus(nextOrderDue.status);
        this.applicationSettings.setTrackingId(nextOrderDue.trackingId.toString());
        this.router.navigateByUrl('/orderconfirm').then();
    }

    StartNextOrder(nextOrderDue: OrderSchedule) {
        if (nextOrderDue == null || nextOrderDue.trackingId == null) {
            return;
        }

        this.configurationService.setOrderStatus(nextOrderDue.status);
        this.startScheduledOrder(nextOrderDue.trackingId.toString(),
            this._storeListService.pickedCustomerId).catch((error) => {
            this.messageBox.ErrorPageAlert(Nomenclatures.DIALOG_ORDER_START_ERROR_MESSAGE).then(r => r);
            throwError(error);
        });
    }

    private async StartInventoryCheck() {
        await this.dialogHelper.open(
            {
                type: DialogType.INFO,
                title: 'Placed Order',
                content: 'Select an Option',
                actions: [
                    {text: 'View Report'},
                    {text: 'Receive Order', themeColor:"primary"}
                ],
                width: 400
            }).then(results => {
            if (results === 'Receive Order') {
                this.router.navigateByUrl('/app-inventory');
            } else if (results === 'View Report') {
                this.router.navigateByUrl('/orderconfirm');
            }
        });
    }
}
